import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9 13a3 3 0 1 1 6 0 3 3 0 0 1-6 0" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3l-.447-.894A2 2 0 0 0 14.763 4H9.237a2 2 0 0 0-1.789 1.106L7 6zm8 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
      clipRule: "evenodd"
    }
  )
);
var SvgAddPhotoFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AddPhotoFilled_default = SvgAddPhotoFilled;

export { AddPhotoFilled_default as default };
